<template>
  <!-- Content -->
  <CForm @submit.prevent="send">
    <Modal :modal="modal"></Modal>
    <CCol col="12">
      <CRow>
        <CCol lg="12">
          <div class="d-flex align-items-center justify-content-end mb-3">
            <a
              href="javascript:void(0)"
              @click="$router.go(-1)"
            ><CIcon
              name="cil-arrow-left"
              class="mr-2"
            />Voltar</a>
          </div>
        </CCol>
      </CRow>
      <CCard>
        <CCardHeader class="d-flex justify-content-between align-items-center">
          <h4 class="mb-0">
            {{ $route.params.id ? 'Editar Vaga' : 'Cadastrar Vaga' }}
          </h4>
          <div class="d-flex align-items-center">
            <div class="ml-2 d-flex align-items-center">
              <label class="mb-0"><b>Status</b></label>
              <CSwitch
                type="checkbox"
                color="success"
                variant="3d"
                class="mx-2"
                v-bind="labelIcon"
                :checked.sync="form.status"
              />
            </div>
          </div>
        </CCardHeader>
        <CCardBody>
          <CRow>
            <CCol
              lg="12"
              md="12"
              sm="12"
            >
              <CRow>
                <CCol
                  lg="4"
                  md="6"
                  sm="12"
                >
                  <div class="form-group">
                    <label for="level">Nível*</label>
                    <Multiselect
                      id="level"
                      v-model="form.job_level"
                      :options="jobLevelOptions"
                      :multiple="false"
                      track-by="value"
                      label="label"
                      :searchable="true"
                      :disabled="processing"
                      :required="true"
                    >
                      <span slot="noResult">Nenhum resultado encontrado</span>
                    </Multiselect>
                  </div>
                </CCol>
                <CCol
                  lg="4"
                  md="6"
                  sm="12"
                >
                  <CInput
                    v-model="form.title"
                    name="title"
                    label="Título*"
                    placeholder="Título da vaga"
                    required
                    :disabled="processing"
                    @blur="checkUrl"
                  />
                </CCol>
                <CCol
                  lg="4"
                  md="6"
                  sm="12"
                >
                  <FriendlyUrl
                    :value="$route.params.id ? form.slug : form.title ? `${form.title} ${form.job_level.label ? form.job_level.label : '' }` : ''"
                    :disabled="processing"
                    :invalid-slug="invalidSlug"
                    :slug-suggested="slugSuggested"
                    @change="setFriendlyUrl"
                    @checkUrl="checkUrl"
                  />
                </CCol>
                <CCol
                  lg="4"
                  md="6"
                  sm="12"
                >
                  <CInput
                    v-model="form.salary"
                    name="salary"
                    label="Salário"
                    placeholder="Salário"
                    :disabled="processing"
                  />
                </CCol>

                <CCol
                  lg="4"
                  md="6"
                  sm="12"
                >
                  <div class="form-group">
                    <label for="localization">Atuação*</label>
                    <Multiselect
                      id="localization"
                      v-model="form.job_localization"
                      :options="jobLocalizationsOptions"
                      :multiple="false"
                      track-by="value"
                      label="label"
                      :searchable="true"
                      :disabled="processing"
                      :required="true"
                    >
                      <span slot="noResult">Nenhum resultado encontrado</span>
                    </Multiselect>
                  </div>
                </CCol>
                <CCol
                  lg="4"
                  md="6"
                  sm="12"
                >
                  <div class="form-group">
                    <label for="nature">Regime*</label>
                    <Multiselect
                      id="nature"
                      v-model="form.job_nature"
                      :options="jobNaturesOptions"
                      :multiple="false"
                      track-by="value"
                      label="label"
                      :searchable="true"
                      :disabled="processing"
                      :required="true"
                    >
                      <span slot="noResult">Nenhum resultado encontrado</span>
                    </Multiselect>
                  </div>
                </CCol>
              </CRow>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
      <CCard>
        <CCardHeader class="d-flex justify-content-between align-items-center">
          <h5>Descrição</h5>
        </CCardHeader>
        <CCardBody>
          <CRow class="mb-4">
            <CCol>
              <label for="job_description">Descrição da vaga</label>
              <TextEditor
                v-model="form.job_description"
                id:="job_description"
                :disabled="processing"
                :type="'text'"
              />
            </CCol>
          </CRow>
          <CRow>
            <CCol>
              <label for="company_description">Descrição da empresa</label>
              <TextEditor
                v-model="form.company_description"
                id:="company_description"
                :disabled="processing"
                :type="'text'"
              />
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
      <CCard>
        <CCardHeader class="d-flex justify-content-between align-items-center">
          <h5>Formação</h5>
        </CCardHeader>
        <CCardBody>
          <CCol sm="12">
            <ListItem
              :items="form.formation"
              :fields="formationInputs"
              :disabled="processing"
            />
          </CCol>
        </CCardBody>
      </CCard>
      <CCard>
        <CCardHeader class="d-flex justify-content-between align-items-center">
          <h5>Atividades</h5>
        </CCardHeader>
        <CCardBody>
          <CCol sm="12">
            <ListItem
              :items="form.activities"
              :fields="activitiesInputs"
              :disabled="processing"
            />
          </CCol>
        </CCardBody>
      </CCard>
      <CCard>
        <CCardHeader class="d-flex justify-content-between align-items-center">
          <h5>Requisitos</h5>
        </CCardHeader>
        <CCardBody>
          <CCol sm="12">
            <ListItem
              :items="form.requirements"
              :fields="requirementsInputs"
              :disabled="processing"
            />
          </CCol>
        </CCardBody>
      </CCard>
      <CCard>
        <CCardHeader class="d-flex justify-content-between align-items-center">
          <h5>Competências e Habilidades</h5>
        </CCardHeader>
        <CCardBody>
          <CCol sm="12">
            <ListItem
              :items="form.skills"
              :fields="skillsInputs"
              :disabled="processing"
            />
          </CCol>
        </CCardBody>
      </CCard>
      <CCard>
        <CCardHeader class="d-flex justify-content-between align-items-center">
          <h5>Diferenciais</h5>
        </CCardHeader>
        <CCardBody>
          <CCol sm="12">
            <ListItem
              :items="form.differentials"
              :fields="differentialsInputs"
              :disabled="processing"
            />
          </CCol>
        </CCardBody>
      </CCard>
      <CCard>
        <CCardHeader class="d-flex justify-content-between align-items-center">
          <h5 class="mb-0">
            SEO
          </h5>
        </CCardHeader>
        <CCardBody>
          <Seo
            :form="form"
            :page-title="form.title"
            :page-description="form.title"
            :is-edit="!!$route.params.id"
          />
        </CCardBody>
      </CCard>
      <CRow v-if="$route.params.id">
        <CCol sm="12">
          <CardLog :log="log" />
        </CCol>
      </CRow>
    </CCol>
    <CCol class="my-4">
      <div class="d-flex justify-content-end align-items-center">
        <a
          v-if="$route.params.id"
          href="javascript:void(0)"
          class="mr-3"
          @click="resetForm"
        >Limpar Alterações</a>
        <CInputCheckbox
          v-else
          label="Criar outro"
          class="mr-3"
          :disabled="processing"
          @update:checked="setRedirect"
        />
        <CButton
          color="success"
          type="submit"
          :disabled="processing"
        >
          {{ processing ? 'Salvando...' : 'Salvar' }}
        </CButton>
      </div>
    </CCol>
  </CForm>
</template>

<script>
import JobService from '@/services/job.service'
import CardLog from '@/components/ui/CardLog'
import Modal from '@/components/ui/Modal'
import { cloneDeep } from 'lodash'
import moment from 'moment'
import Multiselect from '@/components/ui/Multiselect'
import Seo from '@/components/ui/Seo'
import FriendlyUrl from '@/components/ui/FriendlyUrl'
import ListItem from '@/components/ui/ListItem'
import TextEditor from '@/components/ui/TextEditor'

export default {
  metaInfo: {
    title: 'Vaga',
    titleTemplate: '%s - Área Administrativa OW Interactive'
  },

  components: {
    CardLog,
    Multiselect,
    Modal,
    Seo,
    FriendlyUrl,
    ListItem,
    TextEditor
  },

  data () {
    return {
      job: {
        status: true,
        title: '',
        slug: '',
        job_description: '',
        company_description: '',
        job_level: '',
        job_localization: '',
        job_nature: '',
        requirements: [],
        formation: [],
        activities: [],
        skills: [],
        differentials: [],
        temporary: false,
        seo_title: '',
        seo_description: ''
      },
      form: {},
      seo: {
        fields: {
          title: '',
          description: ''
        }
      },
      jobLevelOptions: [
        {
          value: '',
          label: 'Selecione',
          disabled: true
        }
      ],
      jobLocalizationsOptions: [
        {
          value: '',
          label: 'Selecione',
          disabled: true
        }
      ],
      jobNaturesOptions: [
        {
          value: '',
          label: 'Selecione',
          disabled: true
        }
      ],
      jobTemporaryOptions: [
        {
          value: false,
          label: 'Indeterminado'
        },
        {
          value: true,
          label: 'Determinado'
        }
      ],
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      log: {},
      processing: false,
      redirect: true,
      modal: {
        show: false,
        title: '',
        message: '',
        color: ''
      },
      formationInputs: [
        {
          key: 'title',
          label: 'Formação',
          type: 'text',
          required: true,
          disabled: false,
          placeholder: 'Digite a formação',
          _classes: 'col-md-5 col-lg-5',
          _style: ''
        }
      ],
      activitiesInputs: [
        {
          key: 'title',
          label: 'Atividade',
          type: 'text',
          required: true,
          disabled: false,
          placeholder: 'Digite a atividade',
          _classes: 'col-md-5 col-lg-5',
          _style: ''
        }
      ],
      requirementsInputs: [
        {
          key: 'title',
          label: 'Requisito',
          type: 'text',
          required: true,
          disabled: false,
          placeholder: 'Digite o requisito',
          _classes: 'col-md-5 col-lg-5',
          _style: ''
        }
      ],
      skillsInputs: [
        {
          key: 'title',
          label: 'Competência / Habilidade',
          type: 'text',
          required: true,
          disabled: false,
          placeholder: 'Digite a competência',
          _classes: 'col-md-5 col-lg-5',
          _style: ''
        }
      ],
      differentialsInputs: [
        {
          key: 'title',
          label: 'Diferencial',
          type: 'text',
          required: true,
          disabled: false,
          placeholder: 'Digite o diferencial',
          _classes: 'col-md-5 col-lg-5',
          _style: ''
        }
      ],
      invalidSlug: false,
      slugSuggested: ''
    }
  },

  async created () {
    await this.getFormOptions()

    if (this.$route.params.id) {
      const response = await JobService.getJobInformation(
        this.$route.params.id
      )

      this.job = {
        id: response.id,
        title: response.title,
        slug: response.slug,
        job_description: response.job_description,
        company_description: response.company_description,
        job_level: response.job_level && {
          value: response.job_level.id,
          label: response.job_level.title
        },
        job_localization: response.job_localization && {
          value: response.job_localization.id,
          label: response.job_localization.title
        },
        job_nature: response.job_nature && {
          value: response.job_nature.id,
          label: response.job_nature.title
        },
        salary: response.salary,
        formation: JSON.parse(response.formation) || [],
        activities: JSON.parse(response.activities) || [],
        requirements: JSON.parse(response.requirements) || [],
        skills: JSON.parse(response.skills) || [],
        differentials: JSON.parse(response.differentials) || [],
        status: response.status,
        seo_title: response.seo && response.seo.title ? response.seo.title : '',
        seo_description:
              response.seo && response.seo.description ? response.seo.description : ''
      }

      this.log = {
        created_by: response.created ? response.created.name : 'Seed',
        created_at: moment(response.created_at).format('DD/MM/YYYY HH:mm'),
        updated_by: response.updated ? response.updated.name : null,
        updated_at: moment(response.updated_at).format('DD/MM/YYYY HH:mm')
      }
    }

    this.setJob()
  },

  methods: {
    async getFormOptions () {
      const response = await JobService.getJobFormOption()

      const jobLevels = response.jobLevels.map(level => {
        return {
          value: level.id,
          label: level.title
        }
      })

      const jobLocalizations = response.jobLocalizations.map(localization => {
        return {
          value: localization.id,
          label: localization.title
        }
      })

      const jobNatures = response.jobNatures.map(nature => {
        return {
          value: nature.id,
          label: nature.title
        }
      })

      this.jobLevelOptions = [...this.jobLevelOptions, ...jobLevels]
      this.jobLocalizationsOptions = [...this.jobLocalizationsOptions, ...jobLocalizations]
      this.jobNaturesOptions = [...this.jobNaturesOptions, ...jobNatures]
    },
    /**
     * Set categories data to edit
     */
    setJob () {
      this.form = cloneDeep(this.job)
    },

    /**
     * Clear changes on category data
     */
    resetForm () {
      this.setJob()
    },

    /**
     * Should redirect or create another category
     */
    setRedirect (event) {
      this.redirect = !event
    },

    /**
     * Store category's data to endpoint
     */
    async send () {
      this.processing = true

      const data = {
        ...this.form,
        id: this.$route.params.id,
        job_level_id: this.form.job_level && this.form.job_level.value,
        job_localization_id: this.form.job_localization && this.form.job_localization.value,
        job_nature_id: this.form.job_nature && this.form.job_nature.value
      }

      delete data.job_level
      delete data.job_localization
      delete data.job_nature

      let response
      let message

      if (this.$route.params.id) {
        response = await JobService.updateJob(this.$route.params.id, data)
        message = `A vaga <b>${this.form.title}</b> foi atualizada com sucesso`
      } else {
        response = await JobService.storeJob(data)
        message = `A vaga <b>${this.form.title}</b> foi cadastrada com sucesso`
      }
      if (response.status === 200) {
        this.modal = {
          show: true,
          title: 'Sucesso',
          message: message,
          color: 'success',
          redirect: this.redirect
        }

        if (this.redirect) {
          setTimeout(() => {
            this.processing = false
            this.$router.push(
              this.$route.matched[this.$route.matched.length - 2].path
            )
          }, 3000)
        } else {
          this.processing = false
          this.resetForm()
        }
      } else if (response.status === 400) {
        this.modal = {
          show: true,
          title: 'Erro',
          message: response.data[0].message || response.data,
          color: 'danger'
        }

        this.processing = false
      } else {
        this.modal = {
          show: true,
          title: 'Erro',
          message:
            'Houve um erro ao salvar a vaga, por favor tente novamente',
          color: 'danger'
        }

        this.processing = false
      }
    },
    periodOfSelected (date) {
      this.periodOf.value = moment(date).toDate()
    },
    /**
     * Formats date of periodUntil
     */
    periodUntilSelected (date) {
      this.periodUntil.value = moment(date).toDate()
    },

    async setFriendlyUrl (value) {
      this.$set(this.form, 'slug', value)
    },

    async checkUrl () {
      if (this.form.title) {
        const response = await JobService.checkJobUrl(this.form.slug, this.form.id)

        if (response.data) {
          this.invalidSlug = true
          this.slugSuggested = `${this.form.slug}-${moment(new Date()).format('DD-MM-YYYY')}`
        } else {
          this.invalidSlug = false
          this.slugSuggested = ''
        }
      } else {
        this.invalidSlug = false
        this.slugSuggested = ''
      }
    }
  }
}
</script>
